import * as React from 'react';

import { ShowMoreBtn } from '../components';
import { useSelector } from 'react-redux';
import {
  selectIsError,
  selectIsLoading,
  selectOfferHistoryData,
  selectPageNumber,
  selectResultsOnPage,
} from '../../../store/offerHistory/selectors';
import { useHandleShowMoreClick } from './utils/useHandleShowMoreClick';

/**
 * Контейнер управляет кнопкой "Загрузить еще"
 * Проверяет необходимость отрендерить кнопку
 * Выполняет загрузку следующей страницы офферов. По успеху - докинет их в конец списка
 * */
export const ShowMoreContainer: React.FC = () => {
  const offerHistoryData = useSelector(selectOfferHistoryData);
  const offerHistoryLoading = useSelector(selectIsLoading);
  const offerHistoryError = useSelector(selectIsError);
  const pageNumber = useSelector(selectPageNumber);
  const resultsOnPage = useSelector(selectResultsOnPage);
  const handleShowMoreClick = useHandleShowMoreClick();

  if (offerHistoryError) {
    return null;
  }

  if (!offerHistoryData || pageNumber * resultsOnPage >= offerHistoryData.totalCount) {
    return null;
  }

  return <ShowMoreBtn onClick={handleShowMoreClick} loading={offerHistoryLoading} />;
};

ShowMoreContainer.displayName = 'ShowMoreContainer';
